<template>
  <svg
    class="icon"
    aria-hidden="true"
    :style="{
      width: size,
      height: size,
      fill: color || 'var(--df-primary-color)',
    }"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    size: { type: String, default: '1em' },
    color: { type: String, default: '' },
  },
  computed: {
    symbolId() {
      return this.name.startsWith('#')
        ? this.name
        : `#${this.name.startsWith('icon-') ? this.name : 'icon-' + this.name}`;
    },
  },
};
</script>

<style scoped>
.icon {
  vertical-align: -0.15em;
  overflow: hidden;
  display: inline-block;
}
</style>